import { useNode } from '@craftjs/core';
import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { HookFormDropDownField } from 'src/features/generalForms/uikit/hookFormFields/hookFormDropDownField';
import { useHookFieldErrors } from 'src/helpers/error-helpers';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';
import { useMemo } from 'react';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

export const FormDropDownInput: FormDropdownInputComponent = (props) => {
  const {
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  const errors = useHookFieldErrors(props.dataKey!);
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Inputs.DropDown');

  const options: DropdownOption[] = useMemo(
    () =>
      props.options?.map((option) => ({
        key: option.key,
        text: option.value,
      })) ?? [],
    [props.options],
  );

  if (!visible) {
    return <></>;
  }

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormDropDownField
        control={form.control}
        name={props.dataKey!}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        placeholder={props.placeholder}
        suggestion={props.suggestion}
        disabled={isDisabled}
        isRequired={!props.isOptional}
        options={options}
        rules={hookFormRules({
          required: !props.isOptional && !isDisabled,
        })}
        emptyOptionLabel={t('NotSelected')}
        errorProps={{ errors }}
      />
    </div>
  );
};
